import { useTranslation } from 'react-i18next'
import SystemDiagram from './SystemDiagram'

export default function Hero() {
  const { t } = useTranslation()
  return (
    <section className="relative overflow-hidden py-32 md:py-40 px-6 text-center">
      {/* Background glow */}
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[500px] rounded-full bg-indigo-300/20 blur-[120px]" />
        <div className="absolute top-20 left-1/3 w-[400px] h-[300px] rounded-full bg-blue-300/18 blur-[100px]" />
        <div className="absolute top-10 right-1/3 w-[350px] h-[250px] rounded-full bg-violet-300/16 blur-[100px]" />
      </div>

      {/* Od 1024 px text vľavo a schéma systému vpravo, pod tým pôvodný úvod na stred */}
      <div className="max-w-5xl lg:max-w-6xl mx-auto lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,24rem)] lg:items-center lg:gap-16">
      <div className="flex flex-col items-center lg:items-start lg:text-left gap-7">
        <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-widest text-indigo-300 bg-indigo-500/15 border border-indigo-400/30 px-4 py-2 rounded-full">
          <span className="w-1.5 h-1.5 rounded-full bg-indigo-300 animate-pulse" />
          {t('hero.badge')}
        </span>

        <h1 className="text-5xl md:text-7xl lg:text-6xl font-extrabold leading-tight tracking-tight text-gradient max-w-4xl">
          {t('hero.title')}
        </h1>

        <p className="text-lg md:text-xl text-slate-200/80 max-w-2xl leading-relaxed">
          {t('hero.subtitle')}
        </p>

        <div className="flex flex-wrap gap-4 justify-center lg:justify-start mt-2">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 font-semibold rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-7 py-3.5 text-sm hover:from-blue-500 hover:to-indigo-500 transition-all shadow-lg shadow-indigo-500/20"
          >
            {t('hero.cta_contact')}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
              <path fillRule="evenodd" d="M3 10a.75.75 0 0 1 .75-.75h10.638L10.23 5.29a.75.75 0 1 1 1.04-1.08l5.5 5.25a.75.75 0 0 1 0 1.08l-5.5 5.25a.75.75 0 1 1-1.04-1.08l4.158-3.96H3.75A.75.75 0 0 1 3 10Z" clipRule="evenodd" />
            </svg>
          </a>
          <a
            href="#projects"
            className="inline-flex items-center gap-2 font-semibold rounded-xl border border-white/20 bg-white/10 text-slate-100 px-7 py-3.5 text-sm hover:bg-white/15 hover:text-white hover:border-white/30 transition-all"
          >
            {t('hero.cta_projects')}
          </a>
        </div>

        {/* Stats row */}
        <div className="mt-8 flex flex-wrap justify-center lg:justify-start gap-8 md:gap-16 lg:gap-12">
          {[
            { value: '5+', label: t('hero.stat_years') },
            { value: '24/7', label: t('hero.stat_support') },
            { value: '100%', label: t('hero.stat_dedicated') },
          ].map(s => (
            <div key={s.value} className="text-center lg:text-left">
              <div className="text-2xl md:text-3xl font-bold text-gradient-blue">{s.value}</div>
              <div className="text-xs text-slate-300/75 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      <SystemDiagram />
      </div>
    </section>
  )
}
